export default __webpack_public_path__ + "static/media/Ballroll_00303.bf6b13fd.png";